export default __webpack_public_path__ + "9f2480266c32161800265e85a51990ea.png";